'use strict';

import { slideToggle } from "../functions.js";

document.addEventListener('DOMContentLoaded', () => {
  const sitemapItem = document.querySelectorAll('.sitemap__text');

  if(sitemapItem) {
    sitemapItem.forEach((item) => {
      item.addEventListener('click', (e) => {
        e.target.children[0].classList.toggle('sitemap__toggle--open');
        slideToggle(e.target.nextElementSibling);
      })
    })
  }
});